export default "__VITE_ASSET__CFZdK4KZ__"